import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'waypay'
})
export class WaypayPipe implements PipeTransform {

  transform(arr: any, code: any): any {
    if ( code == '' || code == null || code == undefined || code == 'undefined' || code == 'All' || code == 'Way Pay' || arr == [] || arr == undefined || arr == null) {
      return arr;
    } else{
      return arr.filter((arr: any) =>{
        return arr.waypay.toLowerCase() == code.toLowerCase()
      })
    }
  }

}
